import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Grid2 from "@mui/material/Grid2";
import {
  onEmailChanged,
  selectState,
  unsubscribeAsync,
} from "./UnsubscribePageSlice";
import {
  Box,
  Button,
  Container,
  useMediaQuery,
  useTheme,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

export function UnsubscribePage() {
  const { email } = useParams<{ email: string }>();
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectState);
  const theme = useTheme();
  const lessThanSm = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (email) {
      dispatch(onEmailChanged(email));
    }
  }, [email, dispatch]);
  return (
    <Container maxWidth="sm" disableGutters={lessThanSm}>
      {/* Success state */}
      <Box
        sx={{
          minHeight: "100vh",
          display: state.isSuccessState ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Grid2
          container
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Grid2 size={12}>
            <Typography variant="h2">Unsubscribe</Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="h3">{state.email}</Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="body1">
              You have been unsubscribed from all marketing communications.
            </Typography>
          </Grid2>
        </Grid2>
      </Box>
      {/* Loading State */}
      <Box
        sx={{
          minHeight: "100vh",
          display: state.isLoading && !state.isSuccessState ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Grid2
          container
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Grid2>
            <CircularProgress size={60} />
          </Grid2>
          <Grid2>
            <Typography>Processing</Typography>
          </Grid2>
        </Grid2>
      </Box>
      {/* Form State */}
      <Box
        sx={{
          minHeight: "100vh",
          display: state.isLoading || state.isSuccessState ? "none" : "flex",
          alignItems: "center",
        }}
      >
        <Grid2
          container
          spacing={2}
          sx={{ mt: 2 }}
          columns={{ xs: 6, sm: 6, md: 12 }}
        >
          <Grid2 size={12}>
            <Typography variant="h2">Unsubscribe</Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="h3">{state.email}</Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="body1">
              Are you sure you want to unsubscribe this email address from all
              marketing communications, including special discount offers? You
              will still receive essential transactional emails, such as
              activation codes.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Button
              component="label"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={(e: any) => dispatch(unsubscribeAsync())}
            >
              <Typography variant="h5">Unsubscribe</Typography>
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Container>
  );
}
